<div [class]="minHeightClass()" [ngClass]="customWrapperClasses()">
    @if (loading()) {
        <div class="inner-page-wrapper mx-auto min-h-[730px]">Loading...</div>
    } @else {
        @if (data(); as d) {
            @if (errorText(); as error) {
                <p class="bg-red font-headline text-14 z-999 w-full py-8 text-center leading-27 font-medium text-white">
                    {{ error }}
                </p>
            }
            @if (backButton() && !completed()) {
                <div class="relative z-10 bg-white shadow-md">
                    <div class="inner-page-wrapper text-accent py-16 lg:py-12">
                        <a
                            class="text-accent flex cursor-pointer items-center gap-8"
                            [hyundaiRouterLink]="backButton()"
                        >
                            <i class="icon-chevron-left text-24" aria-hidden="true"></i>
                            <span class="text-16 leading-20">zurück</span>
                        </a>
                    </div>
                </div>
            }
            @if (d.currentStep) {
                @if (d.currentStep.showStepperMenu) {
                    <div class="mx-auto flex w-full max-w-[1280px] lg:h-[80px]">
                        @if (d.stepForStepper.length > 1 || onlyOneStep()) {
                            <div
                                class="w-full px-16 pt-16 lg:mx-auto lg:w-[60%] lg:px-[60px] lg:pt-40"
                                [ngClass]="[d.currentStep.showSidebar ? 'xl:pr-[120px]' : '']"
                            >
                                @if (!onlyOneStep()) {
                                    <div
                                        class="flex justify-center"
                                        [ngClass]="{
                                            hidden: identifier() === 'distribution',
                                        }"
                                    >
                                        @for (
                                            step of d.stepForStepper;
                                            track step;
                                            let index = $index;
                                            let last = $last;
                                            let first = $first
                                        ) {
                                            <button class="relative block" (click)="activateStepById(step.id)">
                                                <!-- stepper step line after first and before last circle-->
                                                @if (first || last) {
                                                    <span
                                                        class="absolute top-7 block h-2 w-48 lg:top-12"
                                                        [ngClass]="{ 'right-0': first || !last, 'left-0': last }"
                                                    ></span>
                                                }
                                                <!-- stepper step line after/before first and last end-->
                                                <!-- stepper step circle -->
                                                <span
                                                    class="relative block size-16 rounded-full text-center transition-all duration-300 ease-in-out lg:top-4"
                                                    [ngClass]="{
                                                        'center lg:m-auto': first || last,
                                                        'bg-accent': d.stepperIndex === index || d.stepperIndex > index,
                                                        'bg-grey-300': d.stepperIndex < index,
                                                    }"
                                                >
                                                    @if (d.stepperIndex > index) {
                                                        <span
                                                            class="bg-checkWhite relative -top-8 left-0 inline-block h-9 w-9"
                                                        ></span>
                                                    }
                                                    @if (d.stepperIndex <= index) {
                                                        <span class="hidden">
                                                            {{ index + 1 }}
                                                        </span>
                                                    }
                                                </span>
                                                <!-- stepper step circle end -->
                                                <!-- stepper step label desktop -->
                                                <p
                                                    class="text-light-text text-10 relative left-0 mt-10 hidden w-16 whitespace-nowrap uppercase lg:flex lg:justify-center"
                                                    [ngClass]="[
                                                        d.stepperIndex === index ? 'font-semibold' : '',
                                                        d.stepperIndex < index ? '' : '',
                                                        d.stepperIndex > index ? '' : '',
                                                        index === d.stepForStepper.length - 1 ? 'right-0' : '',
                                                        !first && !last ? 'text-center' : '',
                                                    ]"
                                                >
                                                    {{ step.label }}
                                                </p>
                                                <!-- stepper step label desktop end-->
                                            </button>
                                            <!-- stepper step line between circles -->
                                            @if (!last) {
                                                <div
                                                    class="relative h-2 top-7 lg:top-12 lg:max-w-60 lg:max-w-full w-full
                                                        {{ d.stepperIndex > index ? 'bg-accent' : '' }}
                                                        {{ d.stepperIndex <= index ? 'bg-grey-300' : '' }}
                                                "
                                                    [ngClass]="{
                                                        active: d.stepperIndex > index,
                                                        inactive: d.stepperIndex <= index,
                                                    }"
                                                ></div>
                                            }
                                            <!-- stepper step line between cicles end-->
                                        }
                                    </div>
                                }
                            </div>
                        }
                        <!-- sidebar bg in stepper row -->
                        @if (!d.stepForStepper.length) {
                            <div class="w-full max-w-[40%]"></div>
                        }
                        @if (d.currentStep.showSidebar) {
                            <div class="bg-grey-100 relative hidden max-w-[40%] lg:block lg:w-full">
                                @if (!completed()) {
                                    <div class="bg-grey-100 absolute h-full w-[50vw]"></div>
                                }
                            </div>
                        }
                        <!-- sidebar bg in stepper row end-->
                    </div>
                }
                <div
                    class="mx-auto w-full max-w-[1440px]"
                    [ngClass]="{
                        'lg:flex lg:flex-row-reverse lg:justify-end': !completed() && d.currentStep.showSidebar,
                        'max-w-none': completed() && customThanksPage(),
                    }"
                >
                    <!-- sidebar -->
                    @if (!completed() && d.currentStep.showSidebar) {
                        <div
                            class="lg:w-[40%]lg:pb-8 bg-grey-100 relative px-24 pt-[18px] lg:min-h-[730px] lg:pt-0 lg:pl-[56px] xl:pr-0"
                        >
                            <div class="bg-grey-100 absolute hidden h-full w-[50vw] lg:block"></div>
                            <div
                                class="relative"
                                [ngClass]="{
                                    'lg:-mt-[40px]': d.currentStep.showStepperMenu,
                                    'lg:py-[40px]': !d.currentStep.showStepperMenu,
                                }"
                            >
                                <ng-content select="[global]" />
                            </div>
                        </div>
                    }
                    <!-- sidebar end-->
                    <!-- step content -->
                    <div
                        class="relative"
                        [ngClass]="{
                            'bg-white px-24 lg:w-[60%] 2xl:max-w-[904px] 2xl:min-w-[904px] 2xl:pr-[106px] 2xl:pl-[112px]':
                                !completed() && d.currentStep.showSidebar,
                            'lg:w-full': completed() || !d.currentStep.showSidebar,
                            'lg:px-24': hasContentPadding(),
                        }"
                    >
                        <div
                            class="absolute top-0 left-0 z-0 hidden h-full w-[800px] -translate-x-full bg-white lg:block"
                        ></div>
                        <ng-content />
                    </div>
                    <!-- step content end-->
                </div>
            }
        }
    }
</div>
